import React, { useState, useEffect, useRef } from "react";
import { motion, useTransform, useViewportScroll } from 'framer-motion';
import { Link } from "gatsby";
import Parallax from "../common/utils/animations/parallax";
import { directions } from "../common/utils/animations/animationConstants";

export default function HomeServiceColumn(props) {
  const { servicesList } = props.data;
  const triggers = [[0.9, 0.8], [0.85, 0.75], [0.8, 0.7], [0.75, 0.65]];
  return (
    <div className="home-service-section section-gap-large">
      <div className="container">
        <div className="home-service-column-list row d-flex flex-wrap">
          {servicesList.map((item, i) => {
            return <Parallax key={i} classes="col home-service-item" id={"home-service-column-item-" + i} direction={directions.LTR} length={50} opacity={true} triggers={triggers[i]}>
              <div className="item-inner">
                <div className="service-icon">
                  <i>
                    <img src={item.image} title={item.title} alt={item.alt} />
                  </i>
                </div>
                {item.content}
              </div>
            </Parallax>;
          })}
        </div>
        <div className="home-service-action text-center">
          <Link to="/services/" className="button button-black right-arrow">Learn More</Link>
        </div>
      </div>
    </div>
  );
}

